import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './zoom.js';
import { redirectUri, clientId, authority } from './Config.js';
import App from './App';
import { PublicClientApplication, EventType } from '@azure/msal-browser';

const pca = new PublicClientApplication({
    auth: {
        clientId: clientId,
        redirectUri: redirectUri,
        authority: authority,
    },
    cache: {
        cacheLocation: 'localStorage', // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set to true for IE 11 or Edge
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 'Error':
                        console.error(message);
                        return;
                    case 'Info':
                        console.info(message);
                        return;
                    case 'Verbose':
                        console.debug(message);
                        return;
                    case 'Warning':
                        console.warn(message);
                        return;
                    default:
                        return;
                }
            }
        },
        windowHashTimeout: 60000,
        iframeHashTimeout: 6000,
        loadFrameTimeout: 0,
        navigateFrameWait: 0
    }
});

pca.addEventCallback((message) => {
    if (message.eventType === EventType.LOGIN_SUCCESS) {
        //console.log(message);
        pca.setActiveAccount(message.payload.account);
    }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>

        <App msalInstance={pca} />

    </React.StrictMode>
);
